export enum NotificationTypeEnum {
    success,
    primary,
    warning,
    danger
}
